import React, { useEffect, useState } from 'react';
import { Footerdemo } from './ui/footer-section';
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";
import { useLocalStorage } from '@/hooks/useLocalStorage';
import { setAnalyticsConsent } from '@/lib/analytics';

export default function CookieSettings() {
  const { toast } = useToast();
  const [preferences, setPreferences] = useLocalStorage('cookiePreferences', {
    necessary: true,
    analytics: false,
    marketing: false,
    preferences: true
  });

  // Initialize consent status based on localStorage
  useEffect(() => {
    const analyticsConsent = localStorage.getItem('analytics-consent');
    if (analyticsConsent !== null) {
      setPreferences(prev => ({ ...prev, analytics: analyticsConsent === 'true' }));
      setAnalyticsConsent(analyticsConsent === 'true');
    }
  }, []);

  const handleSave = () => {
    // Update analytics consent
    localStorage.setItem('analytics-consent', preferences.analytics.toString());
    setAnalyticsConsent(preferences.analytics);
    
    toast({
      title: "Settings saved",
      description: "Your cookie preferences have been updated.",
    });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 container mx-auto px-4 py-16">
        <h1 className="text-4xl font-bold mb-8">Cookie Settings</h1>
        <div className="prose max-w-none">
          <p className="text-lg text-gray-600 mb-6">Manage your cookie preferences</p>

          <div className="space-y-8">
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h3 className="text-lg font-semibold">Necessary Cookies</h3>
                  <p className="text-sm text-gray-600">Required for the website to function properly</p>
                </div>
                <Switch checked={preferences.necessary} disabled />
              </div>
              <p className="text-sm text-gray-500">These cookies are essential and cannot be disabled</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h3 className="text-lg font-semibold">Analytics Cookies</h3>
                  <p className="text-sm text-gray-600">Help us understand how visitors interact with our website</p>
                </div>
                <Switch 
                  checked={preferences.analytics}
                  onCheckedChange={(checked) => setPreferences({...preferences, analytics: checked})}
                />
              </div>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h3 className="text-lg font-semibold">Marketing Cookies</h3>
                  <p className="text-sm text-gray-600">Used to deliver personalized advertisements</p>
                </div>
                <Switch 
                  checked={preferences.marketing}
                  onCheckedChange={(checked) => setPreferences({...preferences, marketing: checked})}
                />
              </div>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h3 className="text-lg font-semibold">Preference Cookies</h3>
                  <p className="text-sm text-gray-600">Remember your settings and preferences</p>
                </div>
                <Switch 
                  checked={preferences.preferences}
                  onCheckedChange={(checked) => setPreferences({...preferences, preferences: checked})}
                />
              </div>
            </div>

            <Button onClick={handleSave} className="w-full">Save Preferences</Button>
          </div>
        </div>
      </div>
      <Footerdemo />
    </div>
  );
}